export enum ChannelDataTypes {
  THREAD = 'Thread',
  ERROR = 'Error'
}
